import React, { useState, useEffect } from 'react';
import { TransitionGroup } from 'react-transition-group';
import Installation from './Installation';
import {ArrowLeftButton, ArrowRightButton} from '../../../../../components/svgs/buttons/ArrowButton';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {colors} from '../../../../../style/constants'

const level1Height = 320;
const level1Width = 575;
const level0Height = 390;
const level0Width = 692;
const levelMinus1Left = 404;
const level0Left = 144;
const level1Left = 0;
const useStyles = makeStyles((theme) => ({
  
  wrapper: {
    height: level0Height,
    margin: '90px 0',
    [theme.breakpoints.down('md')]: {
      margin: '60px 0',
      height: level0Height*0.8,
      [theme.breakpoints.down('sm')]: {
        height: level0Height*0.46,
        [theme.breakpoints.down('xs')]: {
          height: 550*0.27 - 6.75,
          '& > button': {
            width: 15,
            height: 30,
          }
        },
      },
    },
  },
  installations: {
    height: '100%',
    width: 980,
    padding: '0 85px',
    boxSizing: 'border-box',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      width: 980*0.8,
      [theme.breakpoints.down('sm')]: {
        width: 980*0.46,
        [theme.breakpoints.down('xs')]: {
          width: 980*0.27,
        },
      },
    },
    '& .installation': {
      textAlign: 'center',
      color: colors.WHITE,
      fontSize: 40,
      position: 'absolute',
      transition: 'height 0.75s, width 0.75s, left 0.75s, margin-top 0.75s, line-height 0.75s, background-color 0.75s',
      overflow: 'hidden',
      border: '2px solid white',
      boxSizing: 'border-box',
      boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.25)',
    },
    '& .level-1': {
      height: level1Height,
      width: level1Width,
      lineHeight: level1Height,
      left: levelMinus1Left,
      marginTop: (level0Height - level1Height)/2,
      zIndex: 1,
      [theme.breakpoints.down('md')]: {
        height: level1Height*0.8,
        width: level1Width*0.8,
        lineHeight: level1Height*0.8,
        left: levelMinus1Left*0.8,
        marginTop: (level0Height - level1Height)/2*0.8,
        [theme.breakpoints.down('sm')]: {
          height: level1Height*0.46,
          width: level1Width*0.46,
          lineHeight: level1Height*0.46,
          left: levelMinus1Left*0.46,
          marginTop: (level0Height - level1Height)/2*0.46,
          [theme.breakpoints.down('xs')]: {
            height: level1Height*0.27,
            width: level1Width*0.27,
            lineHeight: level1Height*0.27,
            left: levelMinus1Left*0.27,
            marginTop: ((550*0.27 - 6.75) - (level1Height*0.27))/2,
          },
        },
      },
    },
    '& .level0': {
      height: level0Height,
      width: level0Width,
      lineHeight: level0Height,
      left: level0Left,
      zIndex: 3,
      [theme.breakpoints.down('md')]: {
        height: level0Height*0.8,
        width: level0Width*0.8,
        lineHeight: level0Height*0.8,
        left: level0Left*0.8,
        [theme.breakpoints.down('sm')]: {
          height: level0Height*0.46,
          width: level0Width*0.46,
          lineHeight: level0Height*0.46,
          left: level0Left*0.46,
          [theme.breakpoints.down('xs')]: {
            height: 550*0.27 - 6.75,
            width: 980*0.27 - 12,
            lineHeight: 550*0.27,
            left: 6,
          },
        },
      },
    },
    '& .level1': {
      height: level1Height,
      width: level1Width,
      lineHeight: level1Height,
      marginTop: (level0Height - level1Height)/2,
      left: level1Left,
      zIndex: 2,
      [theme.breakpoints.down('md')]: {
        height: level1Height*0.8,
        width: level1Width*0.8,
        lineHeight: level1Height*0.8,
        marginTop: (level0Height - level1Height)/2*0.8,
        left: level1Left*0.8,
        [theme.breakpoints.down('sm')]: {
          height: level1Height*0.46,
          width: level1Width*0.46,
          lineHeight: level1Height*0.46,
          marginTop: (level0Height - level1Height)/2*0.46,
          left: level1Left*0.46,
          [theme.breakpoints.down('xs')]: {
            height: level1Height*0.27,
            width: level1Width*0.27,
            lineHeight: level1Height*0.27,
            marginTop: ((550*0.27 - 6.75) - (level1Height*0.27))/2,
            left: level1Left*0.27,
          },
        },
      },
    }
  }
}));

const Carousel = (props) => {
  const [state, setState] = useState({
    active: 0,
    direction: '',
   })

  const moveLeft = () => {
    setState({
      active: state.active <= 0 ? props.items.length - 1 : state.active - 1,
      direction: 'left'
    })
  }
  
  const moveRight = () => {
    setState({
      active: state.active >= 2 ? 0 : state.active + 1,
      direction: 'right'
    })
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setState({
        active: state.active <= 0 ? props.items.length - 1 : state.active - 1,
        direction: 'left'
      })
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [state.active, state.direction, props.items.length]);
  
  const renderInstallations = () => {
    return props.items.map((item, index) => {
      let level;
      if (state.active === index) {
        level = 0
      }
      if (state.active - 1 === index || state.active + 2 === index) {
        level = -1
      }
      if (state.active + 1 === index || state.active - 2 === index) {
        level = 1
      }
      return (
        <Installation key={index} id={item} level={level}/>
      );
    });
  }

  const classes = useStyles();
  return(
    <Container>
      <Grid className={classes.wrapper} container justifyContent='space-between' alignItems='center'>
        <ArrowLeftButton onClick={moveLeft} />
        <TransitionGroup 
          transitionname={state.direction}
          transitionentertimeout={750}
          transitionleavetimeout={750}
          className={classes.installations}>
          {renderInstallations()}
        </TransitionGroup>
        <ArrowRightButton onClick={moveRight} />
      </Grid>
    </Container>
  )
}

export default Carousel;